// REACT
import { useEffect } from 'react';

// YARN
import { toast } from 'react-toastify';

// SERVICE
import DataGridGroundTypeEffects from './DataGridGroundTypeEffects';
import useToggleSwitch from 'utils/hooks/useToggleSwitch';

// INTERFACES
import { ICulture } from 'components/generics/Interface/ICulture';
import { IGroundType } from 'components/generics/Interface/Api/Response/GroundType/IGroundType';
import { getCultures } from 'services/API/Cooperative';

type GroundTypeEffectsStructureParams = {
  groundTypes: IGroundType[];
  cultures: ICulture[];
  ownerId: number;
  refreshData: Function;
  setCooperativeCultures: Function;
  from: string;
};
const GroundTypeEffectsStructure = ({
  groundTypes,
  cultures,
  ownerId,
  setCooperativeCultures,
  from,
}: GroundTypeEffectsStructureParams) => {
  const { isOrganic } = useToggleSwitch(from, 'groundTypesEffects', () => {}, ownerId, null, null);

  const fetchCooperativeCultures = (isOrganic: boolean, ownerId: number) => {
    if (!ownerId) {
      ownerId = Number(localStorage.getItem('cooperative'));
    }
    getCultures(ownerId, isOrganic, 'rotation')
      .then((res) => {
        setCooperativeCultures(res.data.data);
      })
      .catch((err) => {
        toast.error(err.data);
      });
  };

  useEffect(() => {
    fetchCooperativeCultures(isOrganic, ownerId);
  }, []);

  return (
    <DataGridGroundTypeEffects
      from={from}
      cultures={cultures?.filter((culture) => culture.isCustomized === true)}
      ownerId={ownerId}
      refreshData={fetchCooperativeCultures}
      groundTypes={groundTypes}
    />
  );
};

export default GroundTypeEffectsStructure;
